import { type Meta } from '../types/docs';
import { CANVAS_LIFECYCLE_ANNOUNCEMENT_ID_META_PARAM } from './canvasLifecycleAnalytics';
import { EDIT_IN_CANVAS_OPENED_ACTIONS } from './useTrackEditInCanvasOpened.meta';

const META: Meta = {
  description: 'Called when a user closes a draft canvas without committing it to the backend',
  name: 'canvas_draft_abandoned',
  params: [
    {
      description: 'The location from which the draft canvas was originally created',
      name: 'source',
      required: false,
      type: 'enum',
      values: [
        'board',
        'board_tile',
        'empty_board_cta',
        'library',
        'general_library',
        'asset_selection_bar',
        'all_content_header',
        'canvases',
        'board_canvas_open',
        'all_content_canvas_open',
        'edit_mode_panel',
        'asset_context_menu',
        'asset_modal_quick_tools',
        'asset_modal_versions_menu',
        'asset_modal_video_editor',
        'board_context_menu',
        'asset_hover',
        'asset_multi_select',
        'recent_canvases',
        'announcement',
        'marketing_url',
      ],
    },
    {
      description:
        'Which board empty-state CTA originally opened the draft. Set only for canvas-creation null states: the generate-hint banner (graduated) or the Edit assets pill (floating_action).',
      name: 'type',
      required: false,
      type: 'enum',
      values: ['floating_action', 'graduated'],
    },
    {
      description: 'The id of the board',
      name: 'board_id',
      required: false,
      type: 'string',
    },
    {
      description:
        'The Edit in Canvas job the user picked (same values as edit_in_canvas_opened.action), set only when the abandoned draft came from Edit in Canvas.',
      name: 'edit_in_canvas_action',
      required: false,
      type: 'enum',
      values: [...EDIT_IN_CANVAS_OPENED_ACTIONS],
    },
    {
      description: 'The id of the library',
      name: 'library_id',
      required: false,
      type: 'string',
    },
    CANVAS_LIFECYCLE_ANNOUNCEMENT_ID_META_PARAM,
  ],
};

export default META;
